import axios from "axios";
import Vue from "vue";
import API from "@/api";
import moment from "moment";

const URL = process.env.VUE_APP_API;

const FETCH_ALL_COMPANIES_SUCCESS = "FETCH_ALL_COMPANIES_SUCCESS";

const defaultState = {
  company: null,
  companies: [],
  loading: false,
};
const mutations = {
  [FETCH_ALL_COMPANIES_SUCCESS](state, payload) {
    Vue.set(state, "companies", payload);
  },
  setCompaniesLoading(state, val) {
    state.loading = val;
  },
  setCompany(state, val) {
    state.company = val;
  },
};

const actions = {
  fetchAllCompanies({ state, commit, rootState }) {
    return new Promise((resolve) => {
      commit("setCompaniesLoading", true);
      axios
        .get(`${URL}/companies`)
        .then((res) => {
          commit(FETCH_ALL_COMPANIES_SUCCESS, res.data.companies);
          resolve(res.data.companies);
          commit("setCompaniesLoading", false);
        })
        .catch((err) => {
          resolve(err);
          commit("setCompaniesLoading", false);
        });
    });
  },
  fetchCompany({ state, commit, rootState }) {
    return new Promise((resolve) => {
      API.user.getCompany(rootState.user.user.company.id).then((res) => {
        let company = res;
        const currentContract = res.contracts.find((i) => i.is_active);
        company.contract = currentContract;
        company.contract.startDate = moment(currentContract.start_date).format(
          "DD-MM-YY"
        );
        company.contract.endDate = moment(currentContract.end_date).format(
          "DD-MM-YY"
        );
        commit("setCompany", company);
        resolve(company);
      });
    });
  },
};

const getters = {
  getCompaniesState: (state) => {
    return () => state;
  },
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
};
